import React, {Component} from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';

class Pagination extends Component {
    _handleOnPageChange = (pagiantion) => {
        const pageIndex = pagiantion.selected + 1
        const {limit} = this.props;
        this.props.onChangePage(pageIndex, limit);
    }

    render() {
        const {currentPage} = this.props;

        const {numberOfPage} = this.props.paginationInfo;


        return (
            <div className="event-pagination">

                <ReactPaginate
                    forcePage={currentPage - 1}
                    pageCount={numberOfPage}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={1}
                    onPageChange={this._handleOnPageChange}
                    disableInitialCallback
                    containerClassName={"pagination"}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="Previous page-item"
                    nextClassName="Next page-item"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    breakClassName="page-link"
                />
            </div>
        )
    }
}

Pagination.propTypes = {
    paginationInfo: PropTypes.object.isRequired,
    onChangePage: PropTypes.func.isRequired,
}

export default Pagination;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventsPage/Pagination.js